import { useState, useEffect } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

async function safeFetch(url) {
  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const contentType = res.headers.get('content-type') || '';
    if (!contentType.includes('application/json')) throw new Error('Non-JSON response');
    return await res.json();
  } catch {
    return null;
  }
}

export function useYouTubeStats() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    safeFetch(`${API}/api/youtube/stats`)
      .then((d) => setData(d))
      .finally(() => setLoading(false));
  }, []);

  return { data, loading };
}

export function useYouTubeCreators() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    safeFetch(`${API}/api/youtube/creators`)
      .then((d) => setData(d))
      .finally(() => setLoading(false));
  }, []);

  return { data, loading };
}

export function formatCount(num) {
  if (!num || isNaN(num)) return '0';
  if (num >= 1000000) return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M+';
  if (num >= 1000) return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K+';
  return String(num);
}
